import { EyeFilled } from '@ant-design/icons';
import TaggedTooltipButton, { TaggedTooltipButtonOwnProps } from '../TaggedTooltipButton';
import styles from './styles.module.less';

const TaggedViewButton = (props:TaggedTooltipButtonOwnProps) => {
  return (
    <TaggedTooltipButton {...props} icon={<EyeFilled />} className={styles['lightblue-btn']} />
  );
};

export default TaggedViewButton;
